import React from 'react';
import { Link } from 'react-router-dom';
import { Compass, Instagram, Facebook, Youtube, Heart } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import './Footer.css';

function Footer() {
  const { language } = useLanguage();
  const footerLinks = {
    reisen: [
      { label: 'Alle Reiseziele', href: '#destinations' },
      { label: 'Reisekalkulator', href: '#calculator' },
      { label: 'Packlisten-Generator', href: '#packing' },
      { label: 'Flughafen-Lounges', href: '#lounges' }
    ],
    partner: [
      { label: 'Flugbuchungen', href: '#affiliate' },
      { label: 'Unterkünfte', href: '#affiliate' },
      { label: 'Outdoor-Ausrüstung', href: '#affiliate' },
      { label: 'Reiseversicherung', href: '#affiliate' },
      { label: 'Kreditkarten', href: '#affiliate' }
    ],
    info: [
      { label: 'Über uns', href: '#about' },
      { label: 'Kontakt', href: 'mailto:just.travel.worldwide101@gmail.com' },
      { label: 'Impressum', href: '/impressum', isRoute: true }
    ]
  };

  const socialLinks = [
    { icon: Instagram, href: '#', label: 'Instagram' },
    { icon: Facebook, href: '#', label: 'Facebook' },
    { icon: Youtube, href: '#', label: 'YouTube' }
  ];

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-brand">
          <div className="footer-logo">
            <Compass size={36} />
            <span className="footer-logo-text">Just Travel</span>
          </div>
          <p className="footer-tagline">
            Dein Guide für aktive Abenteuer und Budget-Reisen rund um die Welt
          </p>
          <div className="footer-social">
            {socialLinks.map((social, index) => {
              const Icon = social.icon;
              return (
                <a 
                  key={index}
                  href={social.href}
                  className="social-link"
                  aria-label={social.label}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Icon size={20} />
                </a>
              );
            })}
          </div>
        </div>

        <div className="footer-links-grid">
          <div className="footer-links-column">
            <h4 className="footer-column-title">Reisen</h4>
            <ul className="footer-links-list">
              {footerLinks.reisen.map((link) => (
                <li key={`reisen-${link.label}`}>
                  <a href={link.href} className="footer-link">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-links-column">
            <h4 className="footer-column-title">Partner</h4>
            <ul className="footer-links-list">
              {footerLinks.partner.map((link) => (
                <li key={`partner-${link.label}`}>
                  <a href={link.href} className="footer-link">{link.label}</a>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-links-column">
            <h4 className="footer-column-title">Informationen</h4>
            <ul className="footer-links-list">
              {footerLinks.info.map((link) => (
                <li key={`info-${link.label}`}>
                  {link.isRoute ? (
                    <Link to={link.href} className="footer-link">{link.label}</Link>
                  ) : (
                    <a href={link.href} className="footer-link">{link.label}</a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <div className="footer-bottom-content">
          <p className="footer-copyright">
            © 2025 Just Travel. Made with <Heart size={16} fill="var(--coral)" color="var(--coral)" /> by Thomas & Jasmin
          </p>
          <p className="footer-disclosure">
            * Affiliate-Links: Bei Buchungen über unsere Partner-Links erhalten wir eine Provision - 
            für dich entstehen keine Mehrkosten.
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
